//react
import React, { useContext, useState, useEffect, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { Delete } from '@mui/icons-material';
//mui
import { Button, TextField, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, RadioGroup, Radio, FormLabel, Switch, FormGroup, FormControlLabel, CircularProgress, Box, Tabs, Tab, Chip, Typography, TextareaAutosize, Autocomplete, } from '@mui/material';


//context
import AuthContext from '../../../context/AuthContext';
import DrawerContext from '../../../context/DrawerContext';
import ModalContext from '../../../context/ModalContext';


//component
import TextInput from '../../../common/TextInput'
import "../../../Pages/Companies/Companies.scss";
import TiptapEditor from './TiptapEditor';

const ManageCompanyDrawer = ({drawerDetails, defaultTab = "details"}) => {

  // console.log(drawerDetails, "this is data from model");
  // console.log(drawerDetails.countries, "this is countries");

  const authCtx = useContext(AuthContext);
  const modalCtx = useContext(ModalContext);
  const drawerCtx = useContext(DrawerContext);

  const [countries, setCountries] = useState(drawerDetails.countries);
  const [countryValue, setCountryValue] = useState(null);

  let countriesOfOperation = [];
  if(drawerDetails?.operationalCountries) {
    countriesOfOperation = drawerDetails.operationalCountries.map((country) => {
      let countryObj = countries.find((c) => c.id === country.country_id);
      return countryObj;
    });
  }

  const [statusMessage, setStatusMessage] = useState('');
  const [editorContent, setEditorContent] = useState('');
  const [selectedContact, setSelectedContact] = useState(null);
  const [loading, setLoading] = useState(false);  
  const [keywords, setKeywords] = useState([]);
  const [errors, setErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [createCompanyObj, setCreateCompanyObj] = useState({
    companyName: "",
    slug: "",
    contactPerson: "",
    companyWebsite: "",
    email: "",
    mobile: "",
    description: "",
    address: "",
    colour: "",
    isGlobal: true,
    keywords: "",
    userScope: "",
    message: "",
    operationalCountries: [],
    accountType: "",
  });
  const [notes, setNotes] = useState(drawerDetails.notes || []);
  const [companyObj, setCompanyObj] = useState({
    id: drawerDetails.id,
    logo: drawerDetails.logo,
    companyDetails: {
      id: drawerDetails.companyDetails.id,
      orderNo: drawerDetails.companyDetails.orderNo,
      company: drawerDetails.companyDetails.company,
      contact: drawerDetails.companyDetails.contact,
      email: drawerDetails.companyDetails.email,
      mobile: drawerDetails.companyDetails.mobile,
      colour: drawerDetails.companyDetails.colour,
      status: drawerDetails.companyDetails.status,
      slug: drawerDetails.companyDetails.slug,
      description: drawerDetails.companyDetails.description,
      keywords: drawerDetails.companyDetails.keywords,
      tasksCompleted: drawerDetails.companyDetails.tasksCompleted,
      lastTaskCompletedDate: drawerDetails.companyDetails.lastTaskCompletedDate,
      accountType: drawerDetails.companyDetails.accountType,
    },
    contactDetails: {
      contact: drawerDetails.contactDetails.contact,
      email: drawerDetails.contactDetails.email,
      mobile: drawerDetails.contactDetails.mobile,
      status: drawerDetails.contactDetails.status,
    },
    locations: [],
    coupons: 1,
    agents: [],
    notes: drawerDetails.notes || [],
    globalSupplier: drawerDetails.globalSupplier,
    operationalCountries: countriesOfOperation
  });
  const [contacts, setContacts] = useState(drawerDetails.allContacts);
  const [editModeOn, setEditModeOn] = useState(false);
  const [initialContactState, setInitialContactState] = useState(null);
  const [value, setValue] = useState(defaultTab);
  const [editingNoteIndex, setEditingNoteIndex] = useState(null);
  const editorRef = useRef(null);

  // const getInitialContacts = () => {
  //   const directContact = drawerDetails?.contactDetails;
  //   const arrayFromCompany = drawerDetails?.companyDetails?.contacts;
  
  //   if (!arrayFromCompany?.length && directContact) {
  //     return [directContact];
  //   }
  
  //   return arrayFromCompany || [];
  // };
  
  // const [contacts, setContacts] = useState(getInitialContacts());

  useEffect(() => {
    if (drawerCtx.pageUpdate?.page === "Companies") {
      const deletedContactId = drawerCtx.pageUpdate.id;
  
      if (deletedContactId) {
        const updatedContacts = contacts.filter((c) => c.id !== deletedContactId);
        setContacts(updatedContacts);
  
        if (selectedContact?.id === deletedContactId) {
          setSelectedContact(updatedContacts[0] || null);
        }
        handleAddContact();
      }
      drawerCtx.setPageUpdate({ page: "" });
    }
  }, [drawerCtx.pageUpdate]);
  
  
  useEffect(() => {
    if (contacts.length > 0) {
      setSelectedContact(contacts[0]);
      setInitialContactState(contacts[0]);
      setEditModeOn(true);
    }
  }, [contacts]); 

  useEffect(() => {
    if (drawerCtx.pageUpdate?.page === "Companies") {
      const deletedNoteId = drawerCtx.pageUpdate.id;
  
      if (deletedNoteId) {
        const updatedNotes = notes.filter((note) => note.id !== deletedNoteId);
        setNotes(updatedNotes);
      }
  
      drawerCtx.setPageUpdate({ page: "" });
    }
  }, [drawerCtx.pageUpdate]);
  

  useEffect(() => {
    const existingKeywords = drawerDetails?.companyDetails?.keywords || "";
    setKeywords(existingKeywords ? existingKeywords.split("|") : []);
  }, [drawerDetails]);

  console.log(drawerDetails, "this is data from model");
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleBlur = (field) => {
    let fieldValue;
    if (field === "company") fieldValue = companyObj.companyDetails.company;
    if (field === "slug") fieldValue = companyObj.companyDetails.slug;
    if (field === "description") fieldValue = companyObj.companyDetails.description;
    if (field === "keywords") fieldValue = keywords;
  
    const fieldErrors = validateCompanyDetails({ [field]: fieldValue });
    setErrors((prev) => ({ ...prev, [field]: fieldErrors[field] }));
    setTouchedFields((prev) => ({ ...prev, [field]: true }));
  };

  const validateCompanyDetails = (fields = {}) => {
    const errors = {};
  
    const companyName = (fields.companyName !== undefined ? fields.companyName : companyObj.companyDetails.company)?.trim() || "";
    const slug = (fields.slug !== undefined ? fields.slug : companyObj.companyDetails.slug)?.trim() || "";
    const description = (fields.description !== undefined ? fields.description : companyObj.companyDetails.description)?.trim() || "";
    const keywordsArr = (fields.keywords !== undefined ? fields.keywords : keywords) || [];
  
    if (!companyName) {
      errors.company = "Company Name cannot be empty.";
    }

    if(!slug) {
      errors.slug = "Slug cannot be empty.";
    }

    if (!description) {
      errors.description = "Description cannot be empty.";
    } else if (description.length < 30) {
      errors.description = "Description must be at least 30 characters.";
    }
    if (keywordsArr.length === 0) {
      errors.keywords = "At least one keyword is required.";
    }
  
    return errors;
  };

  const updateCompanyDetails = () => {
    const errors = validateCompanyDetails();
    setErrors(errors);
    setTouchedFields({
      company: true,
      slug: true,
      description: true,
      keywords: true,
    });
  
    if (Object.keys(errors).length > 0) {
      return;
    }
  
    setLoading(true);

    const payload = {
      title: companyObj.companyDetails.company,
      slug: companyObj.companyDetails.slug,
      description: companyObj.companyDetails.description,
      keywords: keywords.join("|"),
      operationalCountries: createCompanyObj.operationalCountries,
      isGlobal: createCompanyObj.isGlobal,
      colour: createCompanyObj.colour,
      status: companyObj.companyDetails.status,
      accountType: companyObj.companyDetails.accountType,
    }
    
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${companyObj.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authCtx.token}`,
      },
      body: JSON.stringify(payload),
    })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.status === "success") {
        console.log("Company updated successfully");
        setLoading(false);
        drawerCtx.setPageUpdate({page: "Companies", companyId: companyObj.id});
        drawerCtx.closeDrawer();
      } else {
        console.error("Failed to create company:", data.message);
        setLoading(false);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      setLoading(false);
    });
    
  };

  const addNote = () => {
    if (!editorContent.trim()) return;
  
    setLoading(true);
    setStatusMessage('Saving note...');
  
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${drawerDetails.id}/notes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authCtx.token}`,
      },
      body: JSON.stringify({
        agentId: null,
        note: editorContent,
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          const newNote = {
            id: Date.now(), 
            note: editorContent,
            created_at: new Date().toISOString(),
          };
          setNotes([newNote , ...notes]);
          setEditorContent('');
          editorRef.current?.clearContent();
          drawerCtx.setPageUpdate({page: "Companies", companyId: drawerDetails.id});
          setStatusMessage('Note added successfully.');
        } else {
          console.error('Failed to add note:', data.error || data.message);
          setStatusMessage(data.error || data.message || 'Error adding note.');
        }
      })
      .catch(err => {
        console.error('Error adding note:', err);
        setStatusMessage('Error adding note.');
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => setStatusMessage(''), 3000);
      });
  };  
  
  const updateNote = (noteId, index) => {
    if (!editorContent.trim()) return;
  
    setLoading(true);
    setStatusMessage('Updating note...');
  
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${drawerDetails.id}/notes/${noteId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authCtx.token}`,
      },
      body: JSON.stringify({
        agentId: 0,
        note: editorContent,
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          const updated = [...notes];
          updated[index] = {
            ...updated[index],
            note: editorContent,
          };
          setNotes(updated);
          setEditorContent('');
          editorRef.current?.clearContent();
          setEditingNoteIndex(null);
          setStatusMessage('Note updated successfully.');
        } else {
          console.error('Failed to update note:', data.error || data.message);
          setStatusMessage(data.error || data.message || 'Error updating note.');
        }
      })
      .catch(err => {
        console.error('Error updating note:', err);
        setStatusMessage('Error updating note.');
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => setStatusMessage(''), 3000);
      });
  };  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const formatTimeAgo = (dateString) => {
    const now = new Date();
    const createdDate = new Date(dateString);
    const diffMs = now - createdDate;
  
    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const months = Math.floor(days / 30.44); // Average days in a month
    const years = Math.floor(months / 12);
  
    if (minutes < 1) return "just now";
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
  
    // If less than a month, show days
    if (days < 30) return `${days}d ago`;
  
    // If less than a year, show months and remaining days
    if (months < 12) {
      const remainingDays = days % 30;
      if (remainingDays === 0) {
        return `${months}m ago`;
      }
      return `${months}m ${remainingDays}d ago`;
    }
  
    // If more than a year, show years and remaining months
    const remainingMonths = months % 12;
    if (remainingMonths === 0) {
      return `${years}y ago`;
    }
    return `${years}y ${remainingMonths}m ago`;
  };
  
  useEffect(() => {
    setCompanyObj((prev) => ({
      ...prev,
      companyDetails: { ...prev.companyDetails, }
    }))
  }, []);

  useEffect(() => {
    const isGlobal = companyObj?.globalSupplier;
    const operationalCountries = isGlobal ? [] : (companyObj?.operationalCountries || []);  
    setCreateCompanyObj((prev) => ({
      ...prev,
      isGlobal,
      operationalCountries,
      colour: companyObj?.companyDetails?.colour || "",
      keywords: companyObj?.companyDetails?.keywords || "",
    }));
  }, [companyObj]);  

  const handleAddContact = () => {
    setEditModeOn(false);
    setSelectedContact({
      id: null,
      contact: '',
      email: '',
      mobile: '',
      status: 'prospect',
    });
    setInitialContactState(null);
  };

  const handleAddNewContact = () => {
    console.log(selectedContact, "this is selected contact");
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${companyObj.id}/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authCtx.token}` },
      body: JSON.stringify(selectedContact),
    })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.status === "success") {
        console.log("Company updated successfully");
        drawerCtx.setPageUpdate({page: "Companies", companyId: companyObj.id});
        setLoading(false);        
        let newContact = { ...selectedContact, id: data.id };
        setContacts([...contacts, newContact]);
        handleAddContact();
      } else {
        console.error("Failed to create company:", data.message);
        setLoading(false);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      setLoading(false);
    });
  }
  
  const handleSaveContact = () => {
    if (!selectedContact?.contact || !selectedContact?.email) {
      return;
    }
    setLoading(true);

    // Simply check if this contact is the first one in the allContacts array
    const isInitial = drawerDetails.allContacts[0]?.id === selectedContact.id;
    
    let payload = {
      contact: selectedContact.contact,
      email: selectedContact.email,
      mobile: selectedContact.mobile,
      status: selectedContact.status,
      isInitial: isInitial,
    }
    console.log(payload, "this is selected contact");
    

    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${companyObj.id}/contact/${selectedContact.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authCtx.token}` },
      body: JSON.stringify(payload),
    })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.status === "success") {
        console.log("Contact updated successfully");
        setLoading(false);
        drawerCtx.setPageUpdate({page: "Companies", companyId: companyObj.id});
        const updatedContacts = contacts.map((c) => c.id === selectedContact.id ? selectedContact : c );
        setContacts(updatedContacts);
        handleAddContact();
      } else {
        console.error("Failed to create company:", data.message);
        setLoading(false);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      setLoading(false);
    });

  };

  const getInitials = (name) => {
    if (!name || typeof name !== "string" || !name.trim() || name.trim().toLowerCase() === "undefined") return "N";
    const words = name.trim().split(/\s+/);
    if (words.length === 1) return words[0][0].toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  const baseAvatarColors = [
    "#00ACC1", // teal
    "#2979FF", // blue
    "#43A047", // green
    "#8E24AA", // purple
    "#D81B60", // pink
    "#FF6F00", // orange
    "#6A1B9A", // deep purple
    "#00897B", // teal
    "#F57C00", // orange
    "#4A148C", // deep purple
    "#00695C", // teal
    "#FF8F00", // orange
  ];
  
  const getAvatarColor = (index) => baseAvatarColors[index % baseAvatarColors.length];

  const isContactModified = () => {
    if (!editModeOn || !initialContactState || !selectedContact) return false;
    return (
      initialContactState.contact !== selectedContact.contact ||
      initialContactState.email !== selectedContact.email ||
      initialContactState.mobile !== selectedContact.mobile
    );
  }
  
  const handleModal = (modal, id) => {
    modalCtx.openModal();
    console.log(modal,id, "this is modal and id");
    modalCtx.setDetails(modal, { companyId: companyObj.id, id: id });
  };

  async function updateLogo(file) {
    try {
      const formData = new FormData();
      formData.append("file", file);
  
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${companyObj.id}/uploadlogo`, {
        method: 'POST',
        headers: {
          Authorization: "Bearer " + authCtx.token,
        },
        body: formData, 
      });
  
      if (!response.ok) {
        throw new Error('Failed to update Logo');
      } else {
        const result = await response.json();
        setCompanyObj((prev) => ({
          ...prev,
          logo: result.imagePath,
        }));
      }
    } catch (error) {
      console.error('Error updating Logo', error);
      throw error;
    }
  }

  useEffect(() => {
    if (editorRef.current && editorContent) {
      editorRef.current.setContent(editorContent);
    }
  }, [editorContent]);

  return (
    <div className="drawer-container">
      <div className="drawer">
        <header><h1 data-aos="fade-right" data-aos-delay="500">Manage Company</h1></header>
        <section>
          <Tabs value={value} onChange={handleChange} textColor="secondary" indicatorColor="secondary" aria-label="Manage Company Tabs" style={{ background: "#f4f4f4" }}>
            <Tab value="details" label="Details" />
            <Tab value="contacts" label="Contacts" />
            <Tab value="branding" label="Branding" />
            <Tab value="notes" label="Notes" />
          </Tabs>
          {value === 'details' && (
            <>
              <div className='form-container'>
                <TextField label="Company Name" fullWidth margin="normal" value={companyObj.companyDetails.company || ""}
                  error={touchedFields.company && !!errors.company}
                  helperText={touchedFields.company && errors.company ? errors.company : " "}
                  onChange={(e) => {  
                    setCompanyObj((prev) => ({
                      ...prev,
                      companyDetails: { ...prev.companyDetails, company: e.target.value, },
                    }));
                    setErrors((prev) => ({ ...prev, company: undefined }));
                    setTouchedFields((prev) => ({ ...prev, company: true }));
                  }}
                  onBlur={() => handleBlur("company")}
                />
                <TextField label="Slug" fullWidth margin="normal" value={companyObj.companyDetails.slug || ''}
                  error={touchedFields.slug && !!errors.slug}
                  helperText={touchedFields.slug && errors.slug ? errors.slug : " "}
                  onChange={(e) => {  
                    setCompanyObj((prev) => ({
                      ...prev,
                      companyDetails: { ...prev.companyDetails, slug: e.target.value, },
                    }));
                    setErrors((prev) => ({ ...prev, slug: undefined }));
                    setTouchedFields((prev) => ({ ...prev, slug: true }));
                  }}
                  onBlur={() => handleBlur("slug")}
                />
                {/* <Autocomplete
                  multiple={!createCompanyObj.isGlobal} 
                  value={ createCompanyObj.isGlobal ? "Globally" : createCompanyObj.operationCountries }
                  onChange={(event, newValue) => {
                    if (Array.isArray(newValue) && newValue.some((item) => item?.name === "Globally")) {
                      setCreateCompanyObj((prev) => ({
                        ...prev,
                        isGlobal: true,
                        operationCountries: [],
                      }));
                    } else if (Array.isArray(newValue)) {
                
                      setCreateCompanyObj((prev) => ({
                        ...prev,
                        isGlobal: false,
                        operationCountries: newValue.filter((item) =>
                          countries.some((country) => country.name === item.name)
                        ),
                      }));
                    } else {
                    
                      setCreateCompanyObj((prev) => ({
                        ...prev,
                        isGlobal: false,
                        operationCountries: [],
                      }));
                    }
                  }}
                  filterOptions={(options, params) => {
                    const { inputValue } = params;
                    if (createCompanyObj.isGlobal) {
                      return [];
                    }            
                    const filteredOptions = options.filter(
                      (option) =>
                        option.name.toLowerCase().includes(inputValue.toLowerCase()) &&
                        option.name !== "Globally"
                    );

                    if (!createCompanyObj.isGlobal && inputValue === "") {
                      return [{ name: "Globally" }, ...filteredOptions];
                    }

                    return filteredOptions;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="country-list"
                  options={[{ name: "Globally" }, ...countries]}
                  getOptionLabel={(option) => (typeof option === "string" ? option : option.name || "")}
                  renderOption={(props, option) => <li {...props}>{option.name}</li>}
                  freeSolo={false} 
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label={
                        !createCompanyObj.isGlobal &&
                        createCompanyObj.operationCountries.length === 0
                          ? "Countries of Operation"
                          : ""
                      } 
                      placeholder={
                        !createCompanyObj.isGlobal &&
                        createCompanyObj.operationCountries.length === 0
                          ? "Countries of Operation"
                          : ""
                      } 
                      error={
                        touchedFields.country &&
                        (!createCompanyObj.isGlobal &&
                          createCompanyObj.operationCountries.length === 0)
                      }
                      helperText={
                        touchedFields.country
                          ? !createCompanyObj.isGlobal &&
                            createCompanyObj.operationCountries.length === 0
                            ? "Please select at least one country."
                            : " "
                          : " "
                      }
                      onBlur={() => {
                        if (
                          !createCompanyObj.isGlobal &&
                          createCompanyObj.operationCountries.length === 0
                        ) {
                          handleBlur("country")
                        }
                      }}
                    />
                  )}
                /> */}
                {/* <Autocomplete
                  multiple={!createCompanyObj.isGlobal}
                  value={ createCompanyObj.isGlobal ? "Globally" : createCompanyObj.operationalCountries }
                  onChange={(event, newValue) => {
                    if (Array.isArray(newValue) && newValue.some((item) => item?.name === "Globally")) {
                      setCreateCompanyObj((prev) => ({
                        ...prev,
                        isGlobal: true,
                        operationalCountries: [],
                      }));
                    } else if (Array.isArray(newValue)) {
                      setCreateCompanyObj((prev) => ({
                        ...prev,
                        isGlobal: false,
                        operationalCountries: newValue.filter((item) => {
                          return countries.some((country) => country.id === item.id)
                        }),
                      }));
                    } else {
                      setCreateCompanyObj((prev) => ({
                        ...prev,
                        isGlobal: false,
                        operationalCountries: [],
                      }));
                    }
                  }}
                  filterOptions={(options, params) => {
                    const { inputValue } = params;
                    if (createCompanyObj.isGlobal) return [];
                    const filteredOptions = options.filter(
                      (option) =>
                        option.name.toLowerCase().includes(inputValue.toLowerCase()) &&
                        option.name !== "Globally"
                    );
                    if (!createCompanyObj.isGlobal && inputValue === "") {
                      return [{ name: "Globally" }, ...filteredOptions];
                    }
                    return filteredOptions;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="country-list"
                  options={[{ name: "Globally" }, ...countries]}
                  getOptionLabel={(option) => (typeof option === "string" ? option : option.name || "")}
                  renderOption={(props, option) => <li {...props}>{option.name}</li>}
                  freeSolo={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label={ !createCompanyObj.isGlobal && createCompanyObj.operationalCountries.length === 0 ? "Countries of Operation" : "" }
                      placeholder={ !createCompanyObj.isGlobal && createCompanyObj.operationalCountries.length === 0 ? "Countries of Operation" : "" }
                      error={ touchedFields.country && (!createCompanyObj.isGlobal && createCompanyObj.operationalCountries.length === 0) }
                      helperText={ touchedFields.country ? !createCompanyObj.isGlobal && createCompanyObj.operationalCountries.length === 0 ? "Please select at least one country." : " " : " " }
                      onBlur={() => {
                        if (!createCompanyObj.isGlobal && createCompanyObj.operationalCountries.length === 0 ) {
                          handleBlur("country");
                        }
                      }}
                    />
                  )}
                /> */}

                <TextField
                  error={touchedFields.description && !!errors.description}
                  helperText={touchedFields.description && errors.description ? errors.description : " "}
                  name="description"
                  label="Description"
                  value={companyObj.companyDetails.description || ""}
                  onChange={(e) => {
                    setCompanyObj((prev) => ({
                      ...prev,
                      companyDetails: { ...prev.companyDetails, description: e.target.value },
                    }));
                    
                    setErrors((prev) => ({ ...prev, description: undefined }));
                    setTouchedFields((prev) => ({ ...prev, description: true }));
                  }}
                  onBlur={() => handleBlur("description")}
                  fullWidth
                  multiline
                  rows={4}
                  placeholder="Enter at least 30 characters..."
                />

                <Autocomplete multiple id="keywords-list" options={[]} freeSolo selectOnFocus clearOnBlur handleHomeEndKeys value={keywords}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      setKeywords([...keywords, newValue]);
                    } else if (newValue && newValue.inputValue) {
                      setKeywords([...keywords, newValue.inputValue]);
                    } else {
                      setKeywords([...newValue]);
                    }

                    setErrors((prev) => ({ ...prev, keywords: undefined }));
                    setTouchedFields((prev) => ({ ...prev, keywords: true }));
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Keywords"
                      error={touchedFields.keywords && !!errors.keywords}
                      helperText={touchedFields.keywords && errors.keywords ? errors.keywords : " "}
                      onBlur={() => handleBlur("keywords")}
                    />
                  )}
                />
                <Typography variant="body2" color="textSecondary">
                  Press Enter after typing a keyword to add it.
                </Typography>

                {/* Account Type */}
                <div>
                  <FormLabel component="legend">Account Type</FormLabel>
                  <RadioGroup 
                    row 
                    value={companyObj.companyDetails.accountType} 
                    onChange={(e) => setCompanyObj((prev) => ({ ...prev, companyDetails: { ...prev.companyDetails, accountType: e.target.value } }))} 
                    name="account_type"
                  >
                    <FormControlLabel value="paid" control={<Radio />} label="Paid Account" />
                    <FormControlLabel value="partner" control={<Radio />} label="Partner" />
                  </RadioGroup>
                </div>
              </div>
              <footer>
                <Button variant="outlined" onClick={() => drawerCtx.closeDrawer()}>Cancel</Button>
                <Button variant="contained" onClick={updateCompanyDetails} disabled={loading}>{loading ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ""} SAVE CHANGES</Button>
              </footer>
            </>
          )}
          {value === "contacts" && (
            <>
              <div className="form-container">
                <div className="form-header">
                  <h1>Contact Details</h1>
                  {editModeOn && ( <Button variant="outlined" className="new-contact-btn" onClick={handleAddContact} style={{ marginLeft: 8 }}>New Contact</Button> )}
                </div>

                <TextField label="Contact Person" fullWidth margin="normal" value={selectedContact?.contact || ""} onChange={(e) => setSelectedContact((prev) => ({ ...prev, contact: e.target.value })) } />
                <TextField label="Email Address" fullWidth margin="normal" value={selectedContact?.email || ""} onChange={(e) => setSelectedContact((prev) => ({ ...prev, email: e.target.value })) } />
                <TextField label="Mobile Number" fullWidth margin="normal" value={selectedContact?.mobile || ""} onChange={(e) => setSelectedContact((prev) => ({ ...prev, mobile: e.target.value })) } />
                <div>
                  <FormLabel component="legend">Contact Status</FormLabel>
                  <RadioGroup row value={selectedContact?.status || ""} onChange={(e) => setSelectedContact((prev) => ({ ...prev, status: e.target.value })) } name="contact-status">
                    <FormControlLabel value="prospect" control={<Radio />} label="Prospect" />
                    <FormControlLabel value="engaged" control={<Radio />} label="Engaged" />
                    <FormControlLabel value="live-free" control={<Radio />} label="Free Listing" />
                    <FormControlLabel value="live-paid" control={<Radio />} label="Paid Listing" />
                  </RadioGroup>
                </div>
              </div>

              <div className="table-container contacts-table">
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow className="location-row">
                        <TableCell className="location-col-title-address">Contact Person</TableCell>
                        <TableCell className="location-col-coords">Email</TableCell>
                        <TableCell className="location-col-coords">Mobile</TableCell>
                        <TableCell className="actions">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className='location-tbody'>
                      {contacts.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            No contacts found
                          </TableCell>
                        </TableRow>
                      ) : (
                        contacts.map((contact, index) => (
                          <TableRow
                            key={index}
                            className={selectedContact?.id === contact.id ? "selected-row" : ""}
                            onClick={() => {
                              setSelectedContact(contact);
                              setInitialContactState(contact);
                              setEditModeOn(true);
                            }}
                          >
                            <TableCell>{contact.contact}</TableCell>
                            <TableCell>{contact.email}</TableCell>
                            <TableCell>{contact.mobile}</TableCell>
                            <TableCell>
                              <Button style={{justifyContent:"left", minWidth:"25px"}} size="small" onClick={(e) => { e.stopPropagation(); setSelectedContact(contact); setInitialContactState(contact); setEditModeOn(true); }}><EditIcon fontSize="small" /></Button>
                              <Button style={{justifyContent:"left", minWidth:"25px"}} size="small" color='error' disabled={index == 0} onClick={(e) => { e.stopPropagation(); handleModal('delete-contacts', contact.id); }}><Delete fontSize="small" /></Button>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

              <footer>
                <Button variant="outlined" className="btn-cancel" onClick={() => drawerCtx.closeDrawer()}>Cancel</Button>
                {editModeOn ? (
                  <Button variant="contained" onClick={handleSaveContact} disabled={loading || !isContactModified()}>{loading ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ""} SAVE CHANGES</Button>
                ) : (
                  <Button variant="contained" onClick={handleAddNewContact} disabled={loading || !selectedContact?.contact || !selectedContact?.email}>{loading ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ""} ADD CONTACT</Button>
                )}
              </footer>
            </>
          )}
          {value === "branding" && (
            <>
              <div className="branding-tab-content">
                <div className="branding-logo-placeholder">
                {companyObj.logo ? (
                  <img src={companyObj.logo} alt="Company Logo" className="branding-logo-image" />
                ) : (
                  <div className="branding-fallback-logo">
                    {companyObj.companyDetails.company
                      ?.split(" ")
                      .map(word => word.charAt(0).toUpperCase())
                      .join("")
                      .slice(0, 2) || "?"}
                  </div>
                )}
                </div>
                <p className="branding-note">(Note: This will be used as a circle logo. Please upload a square image 512x512)</p>
                <div className="branding-file-upload">
                  <input type="file" id="fileInput" style={{ display: "none" }}
                    onChange={async (e) => {
                      const file = e.target.files[0];

                      if (file) {
                        // Create an image object to check dimensions
                        const img = new Image();
                        img.src = URL.createObjectURL(file);

                        img.onload = async () => {
                          // Check if image is smaller than 512x512
                          if (img.height < 512 || img.width < 512) {
                            modalCtx.setDetails('confirm-upload-image-size', {
                              message: `The current image size is ${img.height}x${img.width}. Are you sure you want to continue?`,
                              onConfirm: async () => {
                                try {
                                  await updateLogo(file);
                                } catch (error) {
                                  console.error('Error:', error);
                                }
                              },
                            });

                            modalCtx.openModal();
                          } else {
                            // If image is 512x512 or larger, proceed normally
                            try {
                              await updateLogo(file);
                            } catch (error) {
                              console.error('Error:', error);
                            }
                          }

                          // Clean up the object URL
                          URL.revokeObjectURL(img.src);
                        };
                      }
                    }}
                  />
                  <Button variant="outlined" onClick={() => document.getElementById("fileInput").click()}>Choose File</Button>
                  <span className="branding-filename">
                    {companyObj.logo ? "Logo selected" : "No file chosen"}
                  </span>
                </div>
                <div>
                  <TextField style={{ width: '50%' }} fullWidth name="colour" label="Brand Colour" placeholder="#ffffff" value={createCompanyObj?.colour || ""}
                    onChange={(e) => {
                      const newColor = e.target.value;
                      setCreateCompanyObj((prev) => ({ ...prev, [e.target.name]: newColor }));
                  
                      if (!newColor && companyObj.companyDetails.status === "active") {
                        setCompanyObj((prev) => ({
                          ...prev,
                          companyDetails: { ...prev.companyDetails, status: "draft" },
                        }));
                      }else if(newColor && companyObj.companyDetails.status === "draft") { 
                        setCompanyObj((prev) => ({
                          ...prev,
                          companyDetails: { ...prev.companyDetails, status: "active" },
                        }));
                      }
                    }}
                    onBlur={() => handleBlur("colour")}
                    helperText={
                      touchedFields.colour && errors.colour
                        ? errors.colour
                        : " "
                    }
                    
                    error={touchedFields.colour && !!errors.colour}
                  />
                </div>
              </div>
              <footer>
                <Button variant="outlined" onClick={() => drawerCtx.closeDrawer()}>Cancel</Button>
                <Button variant="contained" onClick={updateCompanyDetails}>Update</Button>
              </footer>
            </>
          )}
          {value === 'notes' && (
            <>
              <div className="notes-container">
                <TiptapEditor ref={editorRef} content={editorContent} onUpdate={(content) => setEditorContent(content)} />
              {/* </div>
              <div className="notes-container" id="notes-editor"> */}
                {/* <ReactQuill value={editorContent} onChange={setEditorContent} modules={quillModules} placeholder="Insert text here..." className="quill-editor" /> */}
                <div className="notes-list">
                  {
                    notes
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .map((note, index) => (
                      <div key={note.id || index} className="note-item">
                        <div className="note-avatar" style={{ background: getAvatarColor(index), color: "#fff" }}>{getInitials(note.contactName || companyObj.companyDetails.company)}</div>
                        <div className="note-details">
                          <div
                            dangerouslySetInnerHTML={{ __html: note.note }}
                            className={`note-content ${note.isExpanded ? '' : 'collapsed'}`}
                          />
                          {note.note.length > 300 && (
                            <Button 
                              className="read-more-button"
                              onClick={() => {
                                const updatedNotes = [...notes];
                                updatedNotes[index] = { ...note, isExpanded: !note.isExpanded };
                                setNotes(updatedNotes);
                              }}
                            >
                              {note.isExpanded ? 'Show Less' : 'Read More'}
                            </Button>
                          )}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div className="note-action">
                            <Button 
                              size="small" 
                              className="note-action-button"
                              onClick={() => { 
                                setEditorContent(note.note); 
                                setEditingNoteIndex(index);
                                const editorContainer = document.querySelector('.notes-container');
                                if (editorContainer) {
                                  editorContainer.scrollIntoView({ behavior: 'smooth' });
                                }
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </Button>
                            <Button size="small" className="note-action-button" color="error" onClick={(e) => { e.stopPropagation(); handleModal('delete-note', note.id); }}>
                              <Delete fontSize="small" />
                            </Button>
                          </div>
                          <div className="note-time with-bullet">
                            {formatTimeAgo(note.created_at)}
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
                {statusMessage && <div className="status-message">{statusMessage}</div>}
              </div>
              <footer>
                <Button variant="outlined" onClick={() => drawerCtx.closeDrawer()}>Cancel</Button>
                {editingNoteIndex !== null ? (
                  <Button className="add-note-button" onClick={() => updateNote(notes[editingNoteIndex].id, editingNoteIndex)} disabled={!editorContent.trim() || loading}>
                    {loading ? <CircularProgress size={20} /> : 'Update Note'}
                  </Button>
                ) : (
                  <Button className="add-note-button" onClick={addNote} disabled={!editorContent.trim() || loading}>
                    {loading ? <CircularProgress size={20} /> : 'Add Note'}
                  </Button>
                )}
              </footer>
            </>
          )}        
          {/* <div className="double-column-form aligned-left margin-top">
            <Button variant='outlined' disabled={!createBlogObj?.title.length} className='btn-primary' >Cancel</Button>
            <Button variant='outlined' disabled={!createBlogObj?.title.length} className='btn-primary' >Save Changes</Button>
            </div> */}
        </section>
      </div>
    </div>
  )
}

export default ManageCompanyDrawer;

